import { useEffect, useState } from "react";
import * as prodService from "./../services/saleng";

export function useProductsBranch(transactionId) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    prodService
      .getProductsBranch(true, transactionId)
      .then((res) => isMounted && setProducts(res.data.data))
      .catch((err) => console.error(err))
      .finally(() => isMounted && setLoading(false));
    return () => {
      isMounted = false;
    };
  }, [transactionId]);

  return { products, loading };
}
